import { timeAgo } from '#pplx/frontend/apps/ask/shared-ui-components/utils/time.js';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
const HOVER_CARD_JUST_NOW_THRESHOLD_MS = 30_000;
export const SIDEBAR_HOVER_CARD_PREVIEW_LIMIT = 280;
/**
 * Hover-card open state that yields to the row's context menu: the card closes
 * when the menu opens and ignores hover changes while it stays open.
 */
export function useSidebarHoverCardOpen(menuIsActive) {
    const [open, setOpen] = useState(false);
    const onOpenChange = useCallback((isOpen) => {
        if (menuIsActive)
            return;
        setOpen(isOpen);
    }, [menuIsActive]);
    useEffect(() => {
        if (menuIsActive)
            setOpen(false);
    }, [menuIsActive]);
    return { open: menuIsActive ? false : open, onOpenChange };
}
/**
 * Narrow relative time for the card's meta row; `null` when the timestamp is
 * missing or unparsable.
 */
export function useSidebarHoverCardRelativeTime(updatedAt) {
    const intl = useIntl();
    const { $t } = intl;
    return useMemo(() => {
        if (!updatedAt)
            return null;
        const updatedAtDate = new Date(updatedAt);
        if (!Number.isFinite(updatedAtDate.getTime()))
            return null;
        const now = new Date();
        if (Math.abs(now.getTime() - updatedAtDate.getTime()) < HOVER_CARD_JUST_NOW_THRESHOLD_MS) {
            return $t({
                defaultMessage: 'Just now',
                description: 'Relative time text shown when the thread is currently being created',
                id: '7d097ea415',
            });
        }
        return timeAgo(updatedAtDate, now, intl, 'narrow', { includeSuffix: false });
    }, [$t, intl, updatedAt]);
}
//# sourceMappingURL=sidebarHoverCardState.js.map